import { render, staticRenderFns } from "./inputBatu.vue?vue&type=template&id=0f4bd6e4&"
import script from "./inputBatu.vue?vue&type=script&lang=js&"
export * from "./inputBatu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports